//import router from '@/router/index.js';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  // TODO: mettre des try catch partout
  async getUsersRoles(context, payload) {
    try {
      // console.log(context);
      // console.log(payload);

      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles');

      if (typeof payload.page !== 'undefined') {
        fetchUrl.searchParams.set('_page', payload.page);
      }

      if (typeof payload.limit !== 'undefined') {
        fetchUrl.searchParams.set('_limit', payload.limit);
      }

      if (typeof payload.offset !== 'undefined') {
        fetchUrl.searchParams.set('_offset', payload.offset);
      }

      if (typeof payload.sort !== 'undefined') {
        let sortString = '';
        Object.keys(payload.sort).forEach(function (item) {
          if (payload.sort[item].active) {
            sortString += item + ':' + payload.sort[item].order + ',';
          }
        });

        if (sortString !== '') {
          fetchUrl.searchParams.set('_sort', sortString.slice(0, -1));
        }
      }

      if (typeof payload.filters !== 'undefined') {
        let filtersString = '';
        payload.filters.forEach((element) => {
          if (element.name === 'state' || element.name === 'locked' || element.name === 'deleted') {
            if (element.value === true) {
              filtersString += element.name + ':1,';
            } else {
              filtersString += element.name + ':0,';
            }
          } else {
            filtersString += element.name + ':' + element.value + ',';
          }
        });

        if (filtersString !== '') {
          fetchUrl.searchParams.set('_filter', filtersString.slice(0, -1));
        } else {
          fetchUrl.searchParams.set('_filter','state:1;0,locked:1;0,deleted:1;0');
        }
      }

      if (typeof payload.excludes !== 'undefined') {
        let excludesString = '';
        let excludeModule = '';
        payload.excludes.forEach((module) => {
          if (typeof module['Users'] !== 'undefined') {
            excludeModule = 'Users';
            excludesString += module['Users'].name + ':' + module['Users'].value + ',';
          }
        });
        if (excludesString !== '') {
          if (excludeModule !== '') {
            if (excludeModule == 'Users') {
              fetchUrl.searchParams.set('_excludeUsers', excludesString.slice(0, -1));
            }
          }
        }
      }

      // console.log(fetchUrl.href);

      const config = {
        method: 'get',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };

      const response = await axios(config);
      return response;
    } catch (err) {
      console.log(err);
    }

    // let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users');
    // fetchUrl.searchParams.set('_page', payload.page);
    // fetchUrl.searchParams.set('_limit', payload.limit);
    // fetchUrl.searchParams.set('_offset', payload.offset);

    // let sortString = '';
    // Object.keys(payload.sort).forEach(function (item) {
    //   if (payload.sort[item].active) {
    //     sortString += item + ':' + payload.sort[item].order + ',';
    //   }
    // });

    // if (sortString !== '') {
    //   fetchUrl.searchParams.set('_sort', sortString.slice(0, -1));
    // }

    // let filtersString = '';
    // payload.filters.forEach((element) => {
    //   if (element.name === 'state' || element.name === 'locked' || element.name === 'deleted') {
    //     if (element.value === true) {
    //       filtersString += element.name + ':1,';
    //     } else {
    //       filtersString += element.name + ':0,';
    //     }
    //   } else {
    //     filtersString += element.name + ':' + element.value + ',';
    //   }
    // });

    // if (filtersString !== '') {
    //   fetchUrl.searchParams.set('_filter', filtersString.slice(0, -1));
    // }

    // //console.log(fetchUrl.href);

    // const config = {
    //   method: 'get',
    //   url: fetchUrl.href,
    //   headers: {
    //     //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
    //     'Content-Type': 'application/json',
    //     Authorization: 'Bearer ' + context.rootState.authentication.userToken
    //   }
    // };

    // const response = await axios(config);

    // //if (response.data.success) {
    //   // // Sets the token time to live in MS (1h)
    //   // //const tokenExpiration = 3600 * 1000;
    //   // const tokenExpiration = 3600 * 1000;
    //   // const tokenExpirationDate = new Date().getTime() + tokenExpiration;
    //   // if (response.data.result === 'Waiting for 2FA code') {
    //   //   context.dispatch('setUserName', {
    //   //     value: payload.email
    //   //   });
    //   //   router.push({
    //   //     name: 'login-2fa',
    //   //     params: {
    //   //       email: payload.email,
    //   //       password: payload.password
    //   //     }
    //   //   });
    //   // } else {
    //   //   context.dispatch('setUser', {
    //   //     userLoggedIn: true,
    //   //     userName: payload.email,
    //   //     userDetails: response.data.result,
    //   //     userToken: response.data.token,
    //   //     userTokenExpiration: tokenExpirationDate
    //   //   });
    //   //   router.push({
    //   //     name: 'dashboard'
    //   //   });
    //   // }
    // //}
    // return response;
  },
  async getUsersRolesForSearch(context) {
    // console.log(context);
    //console.log(payload);

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles?_limit=all');

    const config = {
      method: 'get',
      url: fetchUrl.href,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      }
    };

    const response = await axios(config);
    return response;
  },
  async updateUsersRole(context, payload) {
    //console.log(context);
    //console.log(payload);

    if (typeof payload.state !== 'undefined') {
      if (payload.state === true) {
        payload.state = 1;
      } else {
        payload.state = 0;
      }
    }

    if (typeof payload.locked !== 'undefined') {
      if (payload.locked === true) {
        payload.locked = 1;
      } else {
        payload.locked = 0;
      }
    }

    if (typeof payload.deleted !== 'undefined') {
      if (payload.deleted === true) {
        payload.deleted = 1;
      } else {
        payload.deleted = 0;
      }
    }

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.uuid);

    const config = {
      method: 'put',
      url: fetchUrl.href,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      },
      data: payload
    };

    const response = await axios(config);

    return response;
  },
  async deleteUsersRole(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-users-roles-delete-areyousure'),
      text: payload.i18n('t-users-roles-delete-confirm'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.id);
      const config = {
        method: 'delete',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async cloneUsersRole(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-users-roles-clone-areyousure'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.uuid + '/clone');
      const config = {
        method: 'post',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async disableRoleForUser(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-users-roles-disableforuser-areyousure'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.roleUuid + '/disableuser/' + payload.userUuid);
      const config = {
        method: 'post',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async enableRoleForUser(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-users-roles-enableforuser-areyousure'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.roleUuid + '/enableuser/' + payload.userUuid);
      const config = {
        method: 'post',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async addRoleForUser(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-users-roles-addforuser-areyousure'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.roleUuid + '/adduser/' + payload.userUuid);
      const config = {
        method: 'post',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async removeRoleForUser(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-users-roles-removeforuser-areyousure'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.roleUuid + '/removeuser/' + payload.userUuid);
      const config = {
        method: 'post',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async getUsersRoleByUuid(context, payload) {
    try {
      // console.log(context);
      //console.log(payload);

      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/users/roles/' + payload.uuid);

      //console.log(fetchUrl.href);

      const config = {
        method: 'get',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };

      const response = await axios(config);

      //if (response.data.success) {
      // // Sets the token time to live in MS (1h)
      // //const tokenExpiration = 3600 * 1000;
      // const tokenExpiration = 3600 * 1000;
      // const tokenExpirationDate = new Date().getTime() + tokenExpiration;
      // if (response.data.result === 'Waiting for 2FA code') {
      //   context.dispatch('setUserName', {
      //     value: payload.email
      //   });
      //   router.push({
      //     name: 'login-2fa',
      //     params: {
      //       email: payload.email,
      //       password: payload.password
      //     }
      //   });
      // } else {
      //   context.dispatch('setUser', {
      //     userLoggedIn: true,
      //     userName: payload.email,
      //     userDetails: response.data.result,
      //     userToken: response.data.token,
      //     userTokenExpiration: tokenExpirationDate
      //   });
      //   router.push({
      //     name: 'dashboard'
      //   });
      // }
      //}
      return response;
    } catch (err) {
      console.log(err);
    }
  }
};
